// extracted by mini-css-extract-plugin
var _1 = "ProjectSettings_action__KhgHq";
var _2 = "ProjectSettings_actionsWrapper__qTkp0";
var _3 = "ProjectSettings_dangerZone__6PMvS";
var _4 = "ProjectSettings_headerButton__3I7wu";
var _5 = "ProjectSettings_headerButtonOffset__zIylH";
var _6 = "ProjectSettings_projectName__5YB4H";
var _7 = "ProjectSettings_text__3drDa";
export { _1 as "action", _2 as "actionsWrapper", _3 as "dangerZone", _4 as "headerButton", _5 as "headerButtonOffset", _6 as "projectName", _7 as "text" }
